import { FC } from 'react';
import { Button, LinkButton } from '@cfa/react-core';
import { themeSizes } from '../../../styles/globalStyleVars';
import { IconTicket } from '@tabler/icons-react';
import { AlertsDrawerEmptyState } from './AlertsDrawerEmptyState';

interface Props {
  showChildCaseSuccess?: boolean;
  showSomeErrorsState?: boolean;
  getChildTicketPath?: string;
  goBackToChildCase?: () => void;
}

export const ChildCasesSuccess: FC<Props> = ({
  showChildCaseSuccess,
  showSomeErrorsState,
  getChildTicketPath,
  goBackToChildCase,
}) => {
  const ViewTicketButton = () => (
    <LinkButton size='sm' href={getChildTicketPath}>
      View ticket
    </LinkButton>
  );

  return (
    <>
      {showChildCaseSuccess && (
        <AlertsDrawerEmptyState
          icon={<IconTicket />}
          subheading='Thanks for letting us know your Restaurant is impacted by this
              issue. We’ll send updates as soon as we have them.'
        >
          <ViewTicketButton />
        </AlertsDrawerEmptyState>
      )}
      {showSomeErrorsState && (
        <AlertsDrawerEmptyState
          icon={<IconTicket />}
          description={
            <span>
              There was an issue creating a ticket for all of your Restaurants,
              but we successfully created a ticket for at least one.
              <br />
              <br />
              Please visit Alerts & Outages to try again.
            </span>
          }
        >
          <ViewTicketButton />
          <Button
            variant='outlined'
            size='sm'
            style={{ marginTop: themeSizes.lg }}
            onPress={goBackToChildCase}
          >
            Open Another Ticket
          </Button>
        </AlertsDrawerEmptyState>
      )}
    </>
  );
};
